// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2a8nn","left":"styles_left__3ycMY"};